import MuiTypography from '@mui/material/Typography';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import { Stack, Checkbox, Chip, Tooltip } from '@mui/material';
import moment from 'moment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs from 'dayjs';
import { OperationTypes } from './Data.conf';
import _ from 'lodash';
import RectangleChip from '../../../components/common/RectangleChip.component';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import logbook from '..';
import { API } from '../api';
import DatePicker from '../../../components/form/components/DatePicker.component';
import TimePickerComponent from '../../../components/form/components/TimePicker.component';
import { StatusLogbookListEdit } from '../../../components/logbook/StatusLogbookListEdit.component';
import DriverLogbookListEdit from '../../../components/logbook/DriverLogbookListEdit.component';
import TextField from '../../../components/form/components/TextField.component';
import { Fragment } from 'react';
import * as yup from 'yup';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const isValidTime = (value) => value => {
  if (!value) return true;
  return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
};

const ORDER_PRV = 'PRV';
const ORDER_INT = 'INT';

export const ColumnCheckboxLogbook = {
  id: 'checkbox_select',
  key: 'checkbox_select',
  sort_key: '',
  sortable: false,
  label: '',
  checkbox: true,
  width: '100px',
  selectable: true,
};
export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },

    sort: [
      {
        by: 'collection_delivery_date',
        direction: 'asc',
      },
      {
        by: 'collection_delivery_time',
        direction: 'asc',
      },
    ],
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes.status_logbook_id',
      key: 'status_logbook_id',
      sort_key: 'status_logbook',
      sortable: true,
      label: 'STATUS',
      width: 150,
      checkbox: true,
    },
    {
      id: 'attributes.id_department.data.attributes.name_department',
      key: 'id_department',
      sort_key: 'id_department.name_department',
      sortable: true,
      label: 'DEPARTMENT',
      width: 100,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'YACHT NAME',
      width: 180,
    },
    {
      id: 'attributes.operation_type',
      key: 'operation_type',
      sort_key: 'operation_type',
      sortable: true,
      label: 'SERVICE',
      width: 210,
    },
    {
      id: 'attributes.collection_delivery_date_id',
      key: 'collection_delivery_date_id',
      sort_key: 'collection_delivery_date',
      sortable: true,
      label: 'DATE',
      width: 170,
      checkbox: true,
    },
    {
      id: 'attributes.collection_delivery_time_id',
      key: 'collection_delivery_time_id',
      sort_key: 'collection_delivery_time',
      sortable: true,
      label: 'TIME',
      width: 150,
      checkbox: true,
    },
    {
      id: 'attributes.id_supplier.data.attributes.company_name',
      key: 'id_supplier',
      sort_key: 'id_supplier.company_name',
      sortable: true,
      label: 'SUPPLIER',
      width: 200,
    },
    {
      id: 'attributes.id_location.data.attributes.marina',
      key: 'id_location',
      sort_key: 'id_location.marina',
      sortable: true,
      label: 'LOCATION',
      width: 150,
    },
    {
      id: 'attributes.delivery_manager_on_board',
      key: 'id_delivery_manager_on_board',
      label: 'MANAGER ON BOARD',
      width: 180,
    },
    {
      id: 'attributes.id_location.data.attributes.area',
      key: 'id_location.area',
      sort_key: 'id_location.area',
      sortable: true,
      label: 'AREA',
      width: 100,
    },
    {
      id: 'attributes.id_driver_in_charge_id',
      key: 'id_driver_in_charge_id',
      sort_key: 'id_driver_in_charge.id_users_permissions_user.name',
      sortable: true,
      label: 'DRIVER',
      width: 150,
      checkbox: true,
    },
    {
      id: 'attributes.delivery_notes_id',
      key: 'delivery_notes_id',
      sort_key: 'delivery_notes',
      label: 'LOGISTICS NOTES',
      width: 300,
      checkbox: true,
    },
    {
      id: 'attributes.time_notes_id',
      key: 'time_notes_id',
      sort_key: 'time_notes',
      label: 'DEPARTMENT TIME NOTES',
      width: 300,
      checkbox: true,
    },
    {
      id: 'attributes.collection_delivery_notes_id',
      key: 'collection_delivery_notes_id',
      sort_key: 'collection_delivery_notes',
      label: 'DEPARTMENT PICK UP/DELIVERY NOTES',
      width: 340,
      checkbox: true,
    },
    {
      id: 'attributes.id_delivery_note_id',
      key: 'id_delivery_note',
      label: 'N. Order',
      width: 170,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'collection_delivery_time_id': {
          return (
            <TableCellEdit
              module={{
                ...logbook,
                query: {
                  ...logbook.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'collection_delivery_time'}
              defaultValues={{
                collection_delivery_time: value?.collection_delivery_time,
              }}
              schema={yup.object({
                collection_delivery_time: yup
                  .string()
                  .nullable()
                  .test(
                    'is-time',
                    'Time format invalid', isValidTime)
                  .required('Time is required or invalid'),
              })}
              form={
                <TimePickerComponent
                  name={'collection_delivery_time'}
                  value={value?.collection_delivery_time}
                />
              }
            >
              {value ? (
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                  {value?.collection_delivery_time ? (
                    <Fragment>
                      <AccessTimeIcon color='action' />
                      <MuiTypography
                        sx={{ fontWeight: 'bold', height: 1 }}
                        variant='body1'
                        onClick={onClick}
                      >
                        {moment(
                          value.collection_delivery_time,
                          'HH:mm:ss'
                        ).format('HH:mm')}
                      </MuiTypography>
                    </Fragment>
                  ) : (
                    '-'
                  )}
                </Stack>
              ) : (
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%' }}
                >
                  -
                </MuiTypography>
              )}
            </TableCellEdit>
          );
        }
        case 'collection_delivery_date_id':
          return (
            <TableCellEdit
              module={{
                ...logbook,
                query: {
                  ...logbook.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'collection_delivery_date'}
              defaultValues={{
                collection_delivery_date: value?.collection_delivery_date,
              }}
              schema={yup.object({
                collection_delivery_date: yup
                  .string()
                  .nullable()
                  .test('is-valid-date', 'Date is required', function (value) {
                    return dayjs(value).isValid();
                  })
                  .required('Date is required'),
              })}
              form={
                <DatePicker
                  name={'collection_delivery_date'}
                  value={value?.collection_delivery_date}
                />
              }
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <CalendarIcon color='action' />
                <MuiTypography
                  sx={{ fontWeight: 'bold', height: 1 }}
                  variant='body1'
                  onClick={onClick}
                >
                  {value?.collection_delivery_date
                    ? dayjs(value?.collection_delivery_date).format(
                      'DD-MM-YYYY'
                    )
                    : '-'}
                </MuiTypography>
              </Stack>
            </TableCellEdit>
          );

        case 'id_delivery_manager_on_board':
          const contactOnBoard = _.get(
            value,
            'attributes.id_users_permissions_user.data.attributes'
          );
          const phoneNumber = _.get(value, 'attributes.id_users_permissions_user.data.attributes.phone_number');
          return (
            <Stack>
              <MuiTypography
                variant='body1'
                onClick={onClick}
                sx={{ height: '100%' }}
              >
                {contactOnBoard
                  ? `${contactOnBoard?.name} ${contactOnBoard?.surname}`
                  : '-'}
              </MuiTypography>

              {phoneNumber && (
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%' }}
                  fontWeight={'600'}
                  alignItems={'end'}
                  display={'flex'}
                  justifyItems={'center'}
                >
                  <LocalPhoneIcon style={{ width: 16, paddingRight: 2 }} />

                  {phoneNumber}
                </MuiTypography>
              )}
            </Stack>
          );

        case 'id_driver_in_charge_id':
          return <DriverLogbookListEdit value={value} onClick={onClick} />;

        case 'yacht_name': {
          const attendance =
            value?.attributes?.id_attendance?.data?.[0]?.attributes ||
            value?.attributes?.id_attendance?.data?.attributes ||
            value?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;
          const mexalCode = attendance?.mexal_code || '-';
          const mexalResearchName = attendance?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip title={mexalTooltip || ''}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    variant='body1'
                    sx={{ fontWeight: 'bold' }}
                    onClick={onClick}
                  >
                    {value?.attributes?.yacht_name || '-'}
                  </MuiTypography>
                  {provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {provenence}
                    </MuiTypography>
                  )}
                </Stack>
                <Chip label={`#${value?.id || '-'}`} size='small' />
              </Stack>
            </Tooltip>
          );
        }

        case 'status_logbook_id':
          return <StatusLogbookListEdit value={value} onClick={onClick} />;
        case 'operation_type':
          return value ? (
            <RectangleChip
              width={170}
              onClick={onClick}
              value={value}
              color={_.includes(value, 'YACHT') && '#fff'}
              backgroundColor={
                _.find(OperationTypes, (item) => item.id === value)
                  ?.backgroundColor
              }
              icon={_.find(OperationTypes, (item) => item.id === value)?.icon}
            />
          ) : (
            '-'
          );

        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );
        case 'delivery_notes_id':
          return (
            <TableCellEdit
              module={{
                ...logbook,
                query: {
                  ...logbook.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ delivery_notes: value?.delivery_notes || '' }}
              value={value}
              name={'delivery_notes'}
              form={
                <TextField
                  id='delivery_notes'
                  name='delivery_notes'
                  label='Notes'
                  type='text'
                  multiline
                  rows={5}
                />
              }
            >
              <MuiTypography variant='body1' textAlign={'justify'}>
                {value?.delivery_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'time_notes_id':
          return (
            <TableCellEdit
              module={{
                ...logbook,
                query: {
                  ...logbook.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ time_notes: value?.time_notes || '' }}
              value={value}
              name={'time_notes'}
              form={
                <TextField
                  id='time_notes'
                  name='time_notes'
                  label='Department Time Notes'
                  type='text'
                  multiline
                  rows={5}
                />
              }
            >
              <MuiTypography variant='body1' textAlign={'justify'}>
                {value?.time_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'collection_delivery_notes_id':
          return (
            <TableCellEdit
              module={{
                ...logbook,
                query: {
                  ...logbook.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                collection_delivery_notes: value?.collection_delivery_notes || '',
              }}
              value={value}
              name={'collection_delivery_notes'}
              form={
                <TextField
                  id='collection_delivery_notes'
                  name='collection_delivery_notes'
                  label='Department Pick Up/Delivery Notes'
                  type='text'
                  multiline
                  rows={5}
                />
              }
            >
              <MuiTypography variant='body1' textAlign={'justify'}>
                {value?.collection_delivery_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'id_delivery_note':
          return (value?.id_department === ORDER_PRV ||
            value?.id_department === ORDER_INT) &&
            value?.delivery_note ? (
            <Chip label={`N° ${value?.delivery_note}`} />
          ) : (
            '-'
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
